import { ArdoqId, WithArdoqPersistent } from '@ardoq/api-types';
import {
  DEFAULT_SOLUTION_METADATA,
  getSolutionMetadata,
  type SolutionMetadata,
} from '@ardoq/core';

export enum DashboardTrackingEventsNames {
  OPENED_DASHBOARD_READER = 'opened-dashboard-reader',
  OPENED_DASHBOARD_BUILDER = 'opened_dashboard_builder',
  ADDED_DESCRIPTION_TO_DASHBOARD = 'added_description_in_dashboard_builder',
  ADDED_NAME_TO_DASHBOARD = 'added_name_in_dashboard_builder',
  COPIED_DASHBOARD_URL = 'copied-dashboard-url',
  CLICKED_EXPAND_DASHBOARD_DESCRIPTION_BUTTON = 'clicked_expand_dashboard_description_button',
  DRAGGED_CHART_IN_DASHBOARD_BUILDER = 'dragged_chart_in_dashboard_builder',
  DRAGGED_HEADER_IN_DASHBOARD_BUILDER = 'dragged_header_in_dashboard_builder',
  DUPLICATED_HEADER_IN_DASHBOARD_BUILDER = 'duplicated_header_in_dashboard_builder',
  DUPLICATED_NOTE_IN_DASHBOARD_BUILDER = 'duplicated_note_in_dashboard_builder',
  DUPLICATED_CHART_IN_DASHBOARD_BUILDER = 'duplicated_chart_in_dashboard_builder',
  DUPLICATED_POWER_BI_IFRAME_IN_DASHBOARD_BUILDER = 'duplicated_power_bi_iframe_in_dashboard_builder',
  ADDED_NEW_CHART_IN_DASHBOARD_BUILDER = 'added_new_chart_in_dashboard_builder',
  ADDED_NEW_HEADING_IN_DASHBOARD_BUILDER = 'added_new_heading_in_dashboard_builder',
  ADDED_NEW_NOTE_IN_DASHBOARD_BUILDER = 'added_new_note_in_dashboard_builder',
  SELECTED_CHART_TYPE_IN_DASHBOARD_BUILDER = 'selected_chart_type_in_dashboard_builder',
  SELECTED_REPORT_IN_DASHBOARD_BUILDER = 'selected_report_in_dashboard_builder',
  SELECTED_SURVEY_IN_DASHBOARD_BUILDER = 'selected_survey_in_dashboard_builder',
  SELECTED_FIELD_IN_DASHBOARD_BUILDER = 'selected_field_in_dashboard_builder',
  SELECTED_AGGREGATE_IN_DASHBOARD_BUILDER = 'selected_aggregate_in_dashboard_builder',
  SELECTED_CHART_LABEL_IN_DASHBOARD_BUILDER = 'selected_chart_label_in_dashboard_builder',
  SELECTED_CHART_VALUE_IN_DASHBOARD_BUILDER = 'selected_chart_value_in_dashboard_builder',
  DELETED_CHART_IN_DASHBOARD_BUILDER = 'deleted_chart_in_dashboard_builder',
  DELETED_NOTE_IN_DASHBOARD_BUILDER = 'deleted_note_in_dashboard_builder',
  DELETED_POWER_BI_IFRAME_IN_DASHBOARD_BUILDER = 'deleted_power_bi_iframe_in_dashboard_builder',
  SELECTED_COLOR_FROM_PALETTE_IN_DASHBOARD_BUILDER = 'selected_color_from_palette_in_dashboard_builder',
  SELECTED_COLOR_WITH_HEX_IN_DASHBOARD_BUILDER = 'selected_color_with_hex_in_dashboard_builder',
  SELECTED_COLOR_WITH_COLORPICKER_IN_DASHBOARD_BUILDER = 'selected_color_with_colorpicker_in_dashboard_builder',
  CLICKED_ON_CREATE_NEW_IN_DASHBOARD_OVERVIEW = 'clicked_on_create_new_in_dashboard_overview',
  CLICKED_ON_GO_TO_DASHBOARD_OVERVIEW_DASHBOARD_BUILDER = 'clicked_on_go_to_dashboard_overview_in_dashboard_builder',
  CLICKED_ON_GO_TO_DASHBOARD_OVERVIEW_DASHBOARD_READER = 'clicked_on_go_to_dashboard_overview_in_dashboard_reader',
  CLICKED_ON_SAVE_IN_DASHBOARD_BUILDER = 'clicked_on_save_in_dashboard_builder',
  CLICKED_ON_EDIT_IN_DASHBOARD_READER = 'clicked_on_edit_in_dashboard_reader',
  OPENED_WIDGET_FILTER = 'opened_widget_filter',
  CLICKED_ON_ADD_TO_PRESENTATION_IN_DASHBOARD_READER = 'clicked_on_add_to_presentation_in_dashboard_reader',
  CLICKED_ON_CANCEL_ADD_DASHBOARD_TO_PRESENTATION = 'clicked_on_cancel_add_dashboard_to_presentation',
  CLICKED_ON_ADD_DASHBOARD_TO_PRESENTATION = 'clicked_on_add_dashboard_to_presentation',
  CLICKED_ON_CREATE_NEW_PRESENTATION_FOR_DASHBOARD = 'clicked_on_create_new_presentation_for_dashboard',
  CLICKED_ON_SELECT_EXISTING_PRESENTATION_FOR_DASHBOARD = 'clicked_on_select_existing_presentation_for_dashboard',
  CLICKED_RETURN_TO_DASHBOARD_FROM_REPORT = 'clicked_return_to_dashboard_from_report',
  OPENED_IN_DISCOVER = 'opened_in_discover',
  DASHBOARD_ERROR = 'dashboard_error',
  WIDGET_PREVIEW_ERROR = 'widget_preview_error',
  FETCH_WIDGET_DATA_SOURCES_ERROR = 'fetch_widget_data_sources_error',
  APPLIED_WIDGET_FILTER = 'applied_widget_filter',
  CLOSED_WIDGET_FILTER_WITHOUT_SAVING = 'closed_widget_filter_without_saving',
  ENABLED_NUMBER_WIDGET_TREND = 'enabled_number_widget_trend',
  DISABLED_NUMBER_WIDGET_TREND = 'disabled_number_widget_trend',
  TREND_PERIOD_NUMBER_OF_DAYS_CHANGED = 'trend_period_number_of_days_changed',
  CHART_TITLE_CHANGED = 'dashboard_chart_title_changed',
  CLOSED_EDIT_DASHBOARD_NAME_PANEL = 'closed_edit_dashboard_name_panel',
  CLOSED_EDIT_DASHBOARD_CHART_PANEL = 'closed_edit_dashboard_chart_panel',
  OPENED_FULLSCREEN_WIDGET = 'opened_fullscreen_widget',
  CREATED_DASHBOARD_FILTER = 'created_dashboard_filter',
  UPDATED_DASHBOARD_FILTER = 'updated_dashboard_filter',
  DELETED_DASHBOARD_FILTER = 'deleted_dashboard_filter',
  UPDATED_DASHBOARD_FILTER_VALUES = 'updated_dashboard_filter_values',
  REORDERED_DASHBOARD_FILTER = 'reordered_dashboard_filter',
  ENTERED_LINK_CHARTS_WITH_DASHBOARD_FILTER_MODE = 'entered_link_charts_with_dashboard_filter_mode',
  CLICKED_ON_EDIT_LINK_CHART_WITH_DASHBOARD_FILTER = 'clicked_on_edit_link_chart_with_dashboard_filter',
  CLICKED_ON_UNLINK_CHART_WITH_DASHBOARD_FILTER = 'clicked_on_unlink_chart_with_dashboard_filter',
  CLICKED_ON_LINK_CHART_WITH_DASHBOARD_FILTER = 'clicked_on_link_chart_with_dashboard_filter',
  SELECTED_CHART_FIELD_FOR_DASHBOARD_FILTER = 'selected_chart_field_for_dashboard_filter',
  CLEARED_CHART_FIELD_FROM_DASHBOARD_FILTER = 'cleared_chart_field_from_dashboard_filter',
  CLICKED_ON_AUTO_LINK_DASHBOARD_FILTER_TO_CHARTS = 'clicked_on_auto_link_dashboard_filter_to_charts',
  SAVED_DASHBOARD = 'saved_dashboard',
  CLICKED_DOWNLOAD_USAGE_METRICS_CSV = 'clicked_download_usage_metrics_csv',
}

export enum DashboardEventLocations {
  ARDOQ = 'Ardoq',
  DISCOVER = 'Discover',
  ASSET_MANAGER = 'Asset manager',
  PRESENTATION = 'Presentation',
  HOMEPAGE = 'Home page',
}

type OpenedDashboardPayload = {
  from: DashboardEventLocations;
  resourceId: ArdoqId;
} & SolutionMetadata;

export const getTrackOpenedDashboardPayload = (
  from: DashboardEventLocations,
  dashboardId: ArdoqId
): [string, OpenedDashboardPayload] => [
  DashboardTrackingEventsNames.OPENED_DASHBOARD_READER,
  {
    from,
    resourceId: dashboardId,
    ...DEFAULT_SOLUTION_METADATA,
  },
];

export const getTrackOpenedDashboardPayloadFor = (
  dashboard: { _id: ArdoqId } & WithArdoqPersistent,
  from: DashboardEventLocations
): [string, OpenedDashboardPayload] => [
  DashboardTrackingEventsNames.OPENED_DASHBOARD_READER,
  {
    from,
    resourceId: dashboard._id,
    ...getSolutionMetadata(dashboard),
  },
];

export const getTrackSaveDashboardPayload = (
  dashboard: WithArdoqPersistent | undefined
): [string, SolutionMetadata] => [
  DashboardTrackingEventsNames.CLICKED_ON_SAVE_IN_DASHBOARD_BUILDER,
  dashboard ? getSolutionMetadata(dashboard) : DEFAULT_SOLUTION_METADATA,
];

export const getTrackEditDashboardInReaderPayload = (
  dashboard: WithArdoqPersistent | undefined
): [string, SolutionMetadata] => [
  DashboardTrackingEventsNames.CLICKED_ON_EDIT_IN_DASHBOARD_READER,
  dashboard ? getSolutionMetadata(dashboard) : DEFAULT_SOLUTION_METADATA,
];

export const getTrackAddToPresentationInReaderPayload = (
  dashboard: WithArdoqPersistent | undefined
): [string, SolutionMetadata] => [
  DashboardTrackingEventsNames.CLICKED_ON_ADD_TO_PRESENTATION_IN_DASHBOARD_READER,
  dashboard ? getSolutionMetadata(dashboard) : DEFAULT_SOLUTION_METADATA,
];
